import {
  Box,
  Flex,
  Input,
  Select,
  Spacer,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import useTable from '../TablePagination/UseTable';
import axios from 'axios';
import { FaCheck } from 'react-icons/fa';
import TablePagination from '../TablePagination/TablePagination';
import FailedInventoryModal from './FailedInventoryModal';

function FailedInventoryPage() {
  const [currentItem, setCurrentItem] = useState<any[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [failedItems, setFailedItems] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRegionCode, setSelectedRegionCode] = useState('');
  const [updatedPage, setUpdatePage] = useState(false);
  const [filteredData, setFilteredData] = useState(failedItems);

  const toast = useToast();

  const [currentPage, setCurrentPage] = useState(1);
  const [claimsPerPage, setClaimsPerPage] = useState<number>(10);
  const lastIndex = currentPage * claimsPerPage;
  const firstIndex = lastIndex - claimsPerPage;
  const { slice, range } = useTable(
    filteredData.length > 0 ? filteredData : failedItems,
    currentPage,
    claimsPerPage
  );
  const arrregioncodes: string[] = (process.env.REACT_APP_REGION_CODES as string).split(',');

  const trackingResults = async () => {
    try {
      const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
      const tokenUrl = process.env.REACT_APP_TOKEN_URL_SIS as string;

      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const validationResponse = await axios.get(
          baseurl + '/Validation/Accounts',
          {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + tokenResponse.data.token,
            },
          }
        );
        if (validationResponse.data.success) {
          const filteredData = validationResponse.data.result.filter(
            (item: any) =>
              [
                item.accountno,
                item.regioncode,
                item.healthplanname,
                item.WorkQueueInventoryStatus,
                item.ComponentName,
                item.Remarks,
                item.TransactionStatus,
                item.plantype,
                item.CodeType,
                item.ServiceType,
                item.DeliveryOption,
              ].some(
                value =>
                  value &&
                  value.toLowerCase().includes(searchQuery.toLowerCase())
              )
          );
          setFailedItems(filteredData);
        } else {
          throw new Error('Failed to fetch validation data');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error fetching validation data:', error);
    }
  };

  useEffect(() => {
    trackingResults();
    setUpdatePage(false);
  }, [selectedRegionCode, searchQuery, updatedPage]);

  const handleRegionCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedRegionCode(e.target.value);
  };

  useEffect(() =>{
    const filteredData = selectedRegionCode
      ? failedItems.filter(item => item.regioncode === selectedRegionCode)
      : failedItems;
    setFilteredData(filteredData);
  },[selectedRegionCode, failedItems])
  // Handle the data filtered from search bar
  // const filteredData = selectedRegionCode
  //   ? failedItems.filter(item => item.regioncode === selectedRegionCode)
  //   : failedItems;

  return (
    <>
      <Box display=" flex" flexDirection="column">
        <Flex display="flex" justifyContent="flex-start" flexDir="row">
          <Text pt="2px" mr="5px" fontWeight="bold">
            Region:
          </Text>
          <Select
            isRequired
            value={selectedRegionCode}
            onChange={handleRegionCodeChange}
            mr="10px"
            placeholder="ALL"
            size="sm"
            width="150px"
            mb="5px"
            borderRadius="10px"
            border="1px solid #d3d3d3"
          >
            {arrregioncodes?.map(regioncode => (
                <option key={regioncode} value={regioncode}>
                  {regioncode}
                </option>
              ))}
          </Select>
          <Input
            marginBottom="5px"
            marginTop="15px"
            htmlSize={24}
            width="auto"
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            marginLeft="auto"
          />
        </Flex>

        <TableContainer borderRadius="5px" borderTopColor="black">
          <Table
            variant="striped"
            colorScheme="blackAlpha"
            size="sm"
            overflow="auto"
          >
            <Thead bgColor="#002677">
              <Tr>
                <Th color="white">Region</Th>
                <Th color="white">Account No</Th>
                <Th color="white">Health Plan Name</Th>
                <Th color="white">Plan Type</Th>
                <Th color="white">Code Type</Th>
                <Th color="white">Service Type</Th>
                <Th color="white">Delivery Option</Th>
                <Th color="white">Remarks</Th>
                <Th color="white">Status Code</Th>
                <Th color="white">Status</Th>
                <Th color="white">Component Name</Th>
                <Th color="white" isNumeric>
                  UPDATE
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredData.slice(firstIndex, lastIndex).map((item, index) => (
                <Tr key={index + '_' + item.accountno}>
                  <Td>{item.regioncode}</Td>
                  <Td>{item.accountno}</Td>
                  <Td>
                    {item.healthplanname ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={item.healthplanname}
                        aria-label="healh-plan-name"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.healthplanname.length > 25
                          ? `${item.healthplanname.slice(0, 25)} ...`
                          : item.healthplanname}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td>{item.plantype}</Td>
                  <Td>{item.CodeType}</Td>
                  <Td>{item.ServiceType}</Td>
                  <Td>{item.DeliveryOption}</Td>
                  <Td>
                    {item.Remarks ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={item.Remarks}
                        aria-label="remarks"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.Remarks.length > 40
                          ? `${item.Remarks.slice(0, 40)} ...`
                          : item.Remarks}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td pl="60px">{item.TransactionStatus}</Td>
                  <Td
                    color={
                      item.WorkQueueInventoryStatus == 'SE' ? 'orange' : 'red'
                    }
                  >
                    {item.WorkQueueInventoryStatus}
                  </Td>
                  <Td>{item.ComponentName}</Td>
                  <Td pt="0" pb="0" mt="0" mb="0" pr="35px" isNumeric>
                    <Flex justifyContent="flex-end">
                      <FaCheck
                        onClick={() => {
                          setCurrentItem(item);
                          onOpen();
                        }}
                      />
                    </Flex>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          <Flex display="flex" flexDirection="row">
            <Flex />
            <Spacer />
            <TablePagination
              range={range}
              slice={slice}
              setPage={setCurrentPage}
              page={currentPage}
            />
            <Spacer />
            <Select
              value={claimsPerPage}
              onChange={e => setClaimsPerPage(parseInt(e.target.value))}
              width="100px"
              height="30px"
              mt="5px"
              mr="5px"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex>
        </TableContainer>
      </Box>
      <FailedInventoryModal
        isOpen={isOpen}
        onClose={onClose}
        selectedItem={currentItem}
        setUpdatePage={setUpdatePage}
      />
    </>
  );
}

export default FailedInventoryPage;
